"use client";

import { Box, Typography, Chip } from "@mui/joy";

interface IStatusData {
    label: string;
    count: number;
    color: string;
}
interface IMultiProgressBar {
    statusData: IStatusData[];
}
export default function MultiProgressBar(props: IMultiProgressBar) {
    const { statusData } = { ...props };

    const total = statusData.reduce((acc, item) => acc + item.count, 0);

    return (
        <Box>
            {/* Progress Bar */}
            <Box display="flex" alignItems="center" height={6} mb={1}>
                {statusData.map(({ count, color }, idx) => (
                    <Box
                        key={idx}
                        sx={{
                            height: "100%",
                            width: `${(count / total) * 100}%`,
                            backgroundColor: color,
                            borderRadius: 5,
                            marginRight: idx !== statusData.length - 1 ? "4px" : 0,
                        }}
                    />
                ))}
            </Box>

            {/* Labels */}
            <Box display="flex" justifyContent="space-between" mt={1}>
                {statusData.map(({ label, count, color }, idx) => (
                    <Box key={idx} display="flex" alignItems="center" gap={1}>
                        <Box
                            sx={{
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                backgroundColor: color,
                            }}
                        />
                        <Typography
                            level="body-xs"
                            endDecorator={
                                <Chip
                                    size="sm"
                                    variant="soft"
                                    sx={{ borderRadius: "6px", border: "1px solid", borderColor: "divider" }}
                                >
                                    {count} items
                                </Chip>
                            }
                        >
                            {label}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
